
export default
	props: block: Object
	computed:
		classes: ->  ["image-#{@block.imagePosition || 'left'}"]

